import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  GanttFilter,
  Identifiable,
  OptimizedGantt,
  Sort,
  Zone,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  range: [string, string];
  retrieveGanttCalendarRange(
    request: Boundaries["retrieveGanttCalendarRange"]["request"],
  ): void;
}

function useRetrieveGanttCalendarRange(zone?: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveGanttCalendarRangeRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveGanttCalendarRangeRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveGanttCalendarRangeRequestFailure(zone),
    ),
    range: useSelector(() => selector.getGanttCalendarRange(zone)),
    retrieveGanttCalendarRange: core.retrieveGanttCalendarRange,
  };
}

export { useRetrieveGanttCalendarRange };
